const link = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};
const iconRoot = {
  minWidth: 30,
  '& svg': {
    fontSize: '1.3rem',
  },
};

export default theme => ({
  wrap: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: 60,
    zIndex: theme.zIndex.drawer,
    background: theme.palette.MMColors.main,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 780,
    height: '100%',
    padding: `0 ${theme.spacing(2)}px`,
  },
  dailyYogaHeader: {
    justifyContent: 'center',
    '& a': {
      marginRight: 0,
    },
  },
  leftBox: {
    display: 'flex',
    alignItems: 'center',
  },
  logoLink: {
    display: 'block',
    marginRight: theme.spacing(6),
    height: 40,
    '& img': {
      height: '100%',
    },
  },
  tabletLogoLink: {
    marginRight: theme.spacing(2),
  },
  paper: {
    background: '#344458',
  },
  list: {
    padding: 0,
  },
  gutters: {
    paddingLeft: theme.spacing(1.5),
  },
  root: {
    position: 'relative',
    fontSize: 16,
    '&:not(:last-child)': {
      borderBottom: '1px solid #445873',
    },
  },
  itemsBox: {
    '&:not(:last-child)': {
      borderBottom: '1px solid #445873',
    },
  },
  verticalLabel: {
    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },
  verticalName: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    paddingRight: 8,
    transition: `color 0.2s ${theme.transitions.easing.easeInOut}`,
    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },
  iconRoot,
  iconRootActive: {
    ...iconRoot,
    '& path': {
      color: theme.palette.MMColors.fox,
    },
  },
  link,
  verticalBtn: {
    paddingTop: 2,
    border: 'none',
    whiteSpace: 'nowrap',
    background: 'transparent',
    '&:hover $verticalName': {
      color: theme.palette.MMColors.fox,
    },
    '& svg': {
      fontSize: 20,
    },
  },
  userBtn: {
    border: 'none',
    whiteSpace: 'nowrap',
    background: 'transparent',
    '&:hover $userName': {
      color: theme.palette.MMColors.fox,
    },
  },
  userName: {
    paddingLeft: theme.spacing(0.8),
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    transition: `color 0.2s ${theme.transitions.easing.easeInOut}`,
  },
  upgradeBox: {
    display: 'inline-flex',
    minWidth: 240,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  upgradeMsg: {
    display: 'inline-block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginLeft: 5,
    marginRight: theme.spacing(1.3),
    '& span': {
      fontWeight: 600,
      color: theme.palette.MMColors.fox,
    },
    '&:first-letter': {
      textTransform: 'uppercase',
    },
  },
  upgradeLink: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    padding: `0 ${theme.spacing(2.5)}px`,
    color: theme.palette.MMColors.dark,
    fontWeight: 600,
    '&:first-letter': {
      textTransform: 'uppercase',
    },
    ...theme.action.button(theme.palette.MMColors.fox, theme.transitions.easing.easeInOut),
  },
  linkBtn: {
    ...link,
    background: 'transparent',
    border: 'none',
  },
  languageRoot: {
    padding: `0 ${theme.spacing(3)}px`,
  },
  lockIcon: {
    marginLeft: theme.spacing(),
    fontSize: 16,
  },
  testLangBtn: {
    textTransform: 'none',
  },
  testLangList: {
    padding: 0,
    '& li': {
      fontSize: 16,
    },
  },
  infoMsg: {
    marginTop: 1,
    width: 16,
    height: 16,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.MMColors.fox,
    borderRadius: '50%',
    '& svg': {
      width: 4,
      '& path': {
        color: theme.palette.MMColors.main,
      },
    },
  },
  useMsg: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    marginRight: 4,
    fontSize: 14,
    color: theme.palette.MMColors.fox,
  },
  noMaxWidth: {
    maxWidth: 'none',
    background: 'rgba(41, 53, 69, 0.98)',
    boxShadow: theme.shadows[5],
  },
  infoMsgBlock: {
    fontSize: 16,
    margin: theme.spacing(2),
    '& p': {
      margin: `0 0 ${theme.spacing(0.5)}px`,
    },
  },
});
